import { Hotel, getReferenceCurrency } from 'tokyu-hooks'
import { isEmpty } from 'lodash'
import qs from 'qs'
import {
  HOTEL_SEARCH_ORDER_BY_DEFAULT,
  toSearchResultModel,
} from 'core/bookings'
import { applyUndatedMembershipDiscount } from 'tokyu-hooks'
import { NFT_PLAN_ID } from 'utils/constants'

export const QUERY_AVAILABILITY_SEARCH = 'QUERY_AVAILABILITY_SEARCH'

export const fetchAvailabilitySearch =
  (clientSession: string, _?: string) =>
  async ({ queryKey }: { queryKey: any[] }) => {
    const [
      _key,
      {
        mode,
        hotelCodes,
        amenities,
        numberRoomGuest,
        type,
        orderBy,
        checkIn,
        checkOut,
        roomPlanCodes,
        hotelPlanCodes,
        locale,
        searchType,
        nights,
      },
    ] = queryKey

    const isUndated = searchType === 'undated'

    if (
      !hotelCodes ||
      !numberRoomGuest ||
      !type ||
      (!isUndated && (!checkIn || !checkOut))
    ) {
      return null
    }

    const defaultAmenities = !isEmpty(qs.parse(amenities))
      ? (qs.parse(amenities) as {
          planList: string[]
          roomTypeList: string[]
        })
      : {
          planList: [],
          roomTypeList: [],
        }

    const defaultNumberRoomGuest = !isEmpty(qs.parse(numberRoomGuest))
      ? Object.values(qs.parse(numberRoomGuest))
      : undefined
    const res = await Hotel.searchAvailability({
      baseUrl: process.env.NEXT_PUBLIC_TRIPLA_BASE_URL as string,
      clientSession: clientSession,
      mode,
      hotelCodes: hotelCodes as string[],
      rooms:
        defaultNumberRoomGuest?.map((room: any) => ({
          ...(isUndated
            ? {}
            : { checkin_date: checkIn, checkout_date: checkOut }),
          adults: room?.numberOfAdult,
          children: room?.numberOfChildren,
        })) || [],
      ...(isUndated
        ? { nights: Number(nights), search_type: 'undated' as const }
        : {}),
      type: type || 'plan',
      order: orderBy || HOTEL_SEARCH_ORDER_BY_DEFAULT,
      room_search_filters: Array.from(
        new Set([
          ...(defaultAmenities?.planList || []),
          ...(defaultAmenities?.roomTypeList || []),
        ]),
      ).filter((filter) =>
        mode === 'standard' ? filter !== String(NFT_PLAN_ID) : true,
      ),
      room_plan_codes: roomPlanCodes,
      hotel_plan_codes: hotelPlanCodes?.filter((x: any) => !!x),
      locale,
      mcp_currency: getReferenceCurrency(locale),
    })

    // Undated searches often come back without a sign-in discount, so the
    // membership price is derived from the regular price (5% off) here — the
    // single choke point for every undated consumer of this query: search
    // results and the room-plan detail page. Dated results pass through.
    return toSearchResultModel(
      isUndated ? applyUndatedMembershipDiscount(res?.data) : res?.data,
      mode,
    )
  }
